<template>
  <entry-message-reservation-to-applicant
    class="boss-message-box-reserved"
    :message-reservation="messageReservation"
    :entry-id="entryId"
    :reservation-status-label="reservationDateLabel"
    :use-accordion="false"
    @remove="remove"
    @setMessage="setMessage"
    @downloadFile="downloadFile"
  />
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import EntryMessageReservationToApplicant from '@/components/molecules/EntryMessageReservationToApplicant'
import { downloadFile } from '@/lib/download'

export default {
  components: {
    EntryMessageReservationToApplicant
  },
  props: {
    messageReservation: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: true
    }
  },
  computed: {
    reservedId () {
      return this.messageReservation.entryMailReservationReservedId
    },
    reservationDateLabel () {
      return dayjs(this.messageReservation.reservationDate).format('YYYY/MM/DD(ddd)') + ' 10：00頃 送信開始予定'
    }
  },
  methods: {
    remove () {
      this.$http.secured.delete(`/entry/message/send/entries/${this.entryId}/message/reserved_reservation`).then(() => {
        this.$toasted.global.success({ message: 'メッセージを削除しました' })
        this.$emit('fetchAllMessage')
      })
    },
    setMessage () {
      this.$emit('setMessage', _.cloneDeep(this.messageReservation))
    },
    downloadFile (fileId, fileName) {
      downloadFile(`/entry/view/entries/${this.entryId}/message/reserved_reservations/${this.reservedId}/files/${fileId}/download`, fileName)
    }
  }
}
</script>
